export const welcomePath = '/';

export const questionnairePath = (token) => `/${token}`;
